export default __webpack_public_path__ + "static/media/wrap_shrimp.d0168713.jpg";